import { SET_INTERVENTII, ADD_INTERVENTIE, SET_PROCEDURI, EDIT_PROCEDURA, ADD_PROCEDURA, DELETE_PROCEDURA } from './InterventiiMutations'

import api from '@/api'

export default {
  loadInterventii ({ commit }, payload) {
    api
      .loadInterventii()
      .then(response => commit(SET_INTERVENTII, response))
      .catch(error => {
        console.log('Error: ', error)
      })
  },
  addInterventie ({ commit }, payload) {
    api.addInterventie(payload)
    commit(ADD_INTERVENTIE, payload)
  },
  loadProceduri ({ commit }, payload) {
    api
      .loadProceduri()
      .then(response => commit(SET_PROCEDURI, response))
      .catch(error => {
        console.log('Error: ', error)
      })
  },
  editProcedura ({ commit }, payload) {
    api.editProcedura(payload)
    commit(EDIT_PROCEDURA, payload)
  },
  addProcedura ({ commit }, payload) {
    api.addProcedura(payload)
    commit(ADD_PROCEDURA, payload)
  },
  deleteProcedura ({ commit }, payload) {
    api.deleteProcedura(payload)
    commit(DELETE_PROCEDURA, payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/interventii/InterventiiActions.js